// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5269":"9fa1bf79b68de3b6","7051":"b7f7e2f11f5ab5a9","8785":"51ce930283c4921a"}[chunkId] + ".css";
};